/**
 * MickeyLoader - Loading screen with Mickey head icon & Disneyland background
 * Used as the main loading indicator throughout the app
 */
export default function MickeyLoader({ message = "Loading..." }) {
  return (
    <div className="fixed inset-0 flex items-center justify-center overflow-hidden z-[9998]">
      {/* Disneyland Background */}
      <div 
        className="absolute inset-0"
        style={{
          backgroundImage: 'url(/bg-disneyland.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center top',
          backgroundRepeat: 'no-repeat',
        }}
      />
      {/* Soft white overlay */}
      <div className="absolute inset-0" style={{
        background: 'linear-gradient(180deg, rgba(255,255,255,0.3) 0%, rgba(255,240,250,0.5) 40%, rgba(255,255,255,0.65) 70%, rgba(255,255,255,0.8) 100%)'
      }} />
      
      {/* Content */}
      <div className="relative z-10 flex flex-col items-center">
        {/* Mickey Head with spinning ring */}
        <div className="relative" data-testid="mickey-loader">
          {/* Spinning ring around Mickey */}
          <div 
            className="absolute inset-[-12px] rounded-full border-4 border-pink-200 border-t-pink-500"
            style={{ animation: 'spin 1.2s linear infinite' }}
          />
          
          {/* Mickey Head SVG */}
          <div style={{ animation: 'mickeyBounce 2s ease-in-out infinite' }}>
            <svg width="80" height="76" viewBox="0 0 200 180" style={{ filter: 'drop-shadow(0 4px 12px rgba(0,0,0,0.2))' }}>
              {/* Left Ear */}
              <circle cx="50" cy="38" r="38" fill="#1a1a1a"/>
              {/* Right Ear */}
              <circle cx="150" cy="38" r="38" fill="#1a1a1a"/>
              {/* Head */}
              <circle cx="100" cy="108" r="60" fill="#1a1a1a"/>
              {/* Red pants bottom half */}
              <clipPath id="loader-pants"><rect x="40" y="112" width="120" height="60"/></clipPath>
              <circle cx="100" cy="108" r="58" fill="#E31B23" clipPath="url(#loader-pants)"/>
              {/* Belt */}
              <rect x="42" y="108" width="116" height="5" rx="2.5" fill="#1a1a1a"/>
              {/* Left button */}
              <ellipse cx="80" cy="138" rx="9" ry="12" fill="#FFC72C"/>
              {/* Right button */}
              <ellipse cx="120" cy="138" rx="9" ry="12" fill="#FFC72C"/>
            </svg>
          </div>
        </div>
        
        {/* Loading text */}
        <p className="mt-5 text-purple-700 font-bold text-base animate-pulse" style={{ textShadow: '0 1px 4px rgba(255,255,255,0.8)' }}>
          {message}
        </p>
      </div>
      
      {/* Animations */}
      <style>{`
        @keyframes mickeyBounce {
          0%, 100% { transform: translateY(0) scale(1); }
          50% { transform: translateY(-8px) scale(1.05); }
        }
      `}</style>
    </div>
  );
}

/**
 * Inline Mickey Loader - smaller version for in-page loading states
 */
export function MickeyLoaderInline({ message = "Memuatkan..." }) {
  return (
    <div className="min-h-screen flex items-center justify-center relative overflow-hidden">
      {/* Disneyland Background */}
      <div 
        className="absolute inset-0"
        style={{
          backgroundImage: 'url(/bg-disneyland.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center top',
          backgroundRepeat: 'no-repeat',
        }}
      />
      <div className="absolute inset-0" style={{
        background: 'linear-gradient(180deg, rgba(255,255,255,0.3) 0%, rgba(255,240,250,0.5) 40%, rgba(255,255,255,0.65) 70%, rgba(255,255,255,0.8) 100%)'
      }} />
      
      <div className="relative z-10 flex flex-col items-center">
        <div className="relative">
          <div 
            className="absolute inset-[-10px] rounded-full border-4 border-pink-200 border-t-pink-500"
            style={{ animation: 'spin 1.2s linear infinite' }}
          />
          <div style={{ animation: 'mickeyBounce 2s ease-in-out infinite' }}>
            <svg width="70" height="66" viewBox="0 0 200 180" style={{ filter: 'drop-shadow(0 4px 12px rgba(0,0,0,0.2))' }}>
              <circle cx="50" cy="38" r="38" fill="#1a1a1a"/>
              <circle cx="150" cy="38" r="38" fill="#1a1a1a"/>
              <circle cx="100" cy="108" r="60" fill="#1a1a1a"/>
              <clipPath id="inline-pants"><rect x="40" y="112" width="120" height="60"/></clipPath>
              <circle cx="100" cy="108" r="58" fill="#E31B23" clipPath="url(#inline-pants)"/>
              <rect x="42" y="108" width="116" height="5" rx="2.5" fill="#1a1a1a"/>
              <ellipse cx="80" cy="138" rx="9" ry="12" fill="#FFC72C"/>
              <ellipse cx="120" cy="138" rx="9" ry="12" fill="#FFC72C"/>
            </svg>
          </div>
        </div>
        <p className="mt-4 text-purple-700 font-bold text-sm animate-pulse" style={{ textShadow: '0 1px 4px rgba(255,255,255,0.8)' }}>
          {message}
        </p>
      </div>
      <style>{`
        @keyframes mickeyBounce {
          0%, 100% { transform: translateY(0) scale(1); }
          50% { transform: translateY(-8px) scale(1.05); }
        }
      `}</style>
    </div>
  );
}
